<ul class="text-danger" *ngIf="errorMessages">
    <li *ngFor="let error of errorMessages">
        {{error}}
    </li>
</ul>